import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { NODE_POLARIS } from '../../../constants/constant.urls'
import { GetURL } from '../../../constants/get-url'
import { IProduct } from '../../models/product'

@Injectable({
  providedIn: 'root',
})
export class PolarisDataService {
  private static productList: IProduct[]
  constructor(private http: HttpClient) {}

  public getProductList(): IProduct[] {
    return PolarisDataService.productList
  }

  public retrieveData(callback: any) {
    this.http.get<IProduct[]>(GetURL(NODE_POLARIS)).subscribe({
      next: (data) => {
        PolarisDataService.productList = JSON.parse(JSON.stringify(data))
        callback(data.length > 0)
      },
      error: (error) => {
        console.log('Failed to fetch Polaris service data !!', error)
        callback(false)
      },
    })
  }
}
